import { useCallback, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { apiClient, PlaygroundUsersOut } from 'lib/apiClient'
import { QueryKey } from 'lib/queryClient'

export interface PlaygroundUsersHook {
  data: PlaygroundUsersOut[]
  findUserById: (id: string) => PlaygroundUsersOut | undefined
  isLoading: boolean
  isError: boolean
}

export function usePlaygroundUsers(enabled: boolean = true): PlaygroundUsersHook {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKey.users],
    queryFn: apiClient.getPlaygroundUsers,
    enabled,
  })

  const findUserById = useCallback(
    (id: string) => {
      return data?.find(user => user.id === id)
    },
    [data],
  )

  return useMemo(
    () => ({
      data: data ?? [],
      findUserById,
      isLoading,
      isError,
    }),
    [data, findUserById, isError, isLoading],
  )
}
